import React from "react";

import { useFormContext } from "react-hook-form";
import { RequiredMark } from "@components/inputs/shared";

import { MappedQuestionType } from "@data-types/sow/PlayerSowTypes";

import { MultiSelectOptionType } from "@data-types/sow/PlayerSowEnums";

import {
	SowCustomCheckboxField,
	SowCustomInputField,
} from "@features/player-sow/shared/inputs";

export const SowSingleSelect = (props: { question: MappedQuestionType }) => {
	const { question } = props;

	const { setValue } = useFormContext();

	const handleSelected = (value: string) => {
		setValue(question.abrv, value);
	};

	return (
		<div className="form__field">
			<label className="label u-mar--bottom--tny u-type--wgt--medium">
				{question.name}
				<RequiredMark required />
			</label>
			{question.mappedOptions &&
				question.mappedOptions.map((option) => {
					if (option.type == MultiSelectOptionType.Text) {
						return (
							<SowCustomInputField
								name={`${question.abrv}-custom`}
								id={option.id}
								label={option.name}
								key={option.id}
								required={question.isCustomRequired}
								labelClassName="u-type--wgt--medium"
							/>
						);
					}
					return (
						<SowCustomCheckboxField
							name={question.abrv}
							id={option.id}
							label={option.name}
							value={option.id}
							key={option.id}
							required
							setSelected={handleSelected}
						/>
					);
				})}
		</div>
	);
};
